exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "th{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.custom_tooltip{position:relative;display:inline-block;border-bottom:1px dotted #000;font-weight:400}.custom_tooltip .custom_tooltiptext{visibility:hidden;width:150px;background-color:#000;color:#fff;text-align:center;border-radius:6px;padding:5px 0;position:absolute;z-index:1;top:150%;left:50%;margin-left:-60px;padding:5px;font-size:1em}.custom_tooltip:hover .custom_tooltiptext{visibility:visible}.custom_tooltip .custom_tooltiptext:after{content:\" \";position:absolute;bottom:100%;left:50%;margin-left:-5px;border-width:5px;border-style:solid;border-color:transparent transparent #000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-948f6fe6!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/custom-table.vue
// module id = 374
// module chunks = 0